import { useEffect, useRef } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import config from 'config';

import { EXTERNAL_LINKS } from 'utils';
import { Text } from 'components';
import { CaseIcon, HomeIcon, InfoIcon, TagIcon } from 'components/Icon';

import styles from './SideNav.module.scss';

export type SideNavProps = {
  isOpen?: boolean;
  onClose?(): void;
};

const SideNav = ({ isOpen = false, onClose }: SideNavProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const overlayRef = useRef<HTMLDivElement>(null);
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkIfClickedOutside = (event: MouseEvent) => {
      if (isOpen && !panelRef.current?.contains(event.target as Node)) {
        onClose?.();
      }
    };

    overlayRef.current?.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      overlayRef.current?.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isOpen, onClose]);

  return (
    <div ref={wrapperRef} className={cx(styles.wrapper, { [styles.isOpen]: isOpen })}>
      <div ref={overlayRef} className={styles.overlay} />

      <div className={styles.panel} ref={panelRef}>
        <div className={styles.content}>
          <nav className={styles.list}>
            <ul>
              <li>
                <Link className={styles.link} to="/" onClick={onClose}>
                  <HomeIcon className="mr-16" />
                  <span>Home</span>
                </Link>
              </li>
              <li>
                <Link className={styles.link} to="/pricing" onClick={onClose}>
                  <TagIcon className="mr-16" />
                  <span>Pricing</span>
                </Link>
              </li>
              <li>
                <a className={styles.link} href={EXTERNAL_LINKS.ABOUT}>
                  <InfoIcon className="mr-16" />
                  <span>About</span>
                </a>
              </li>
              <li>
                <a className={styles.link} href={EXTERNAL_LINKS.CAREERS}>
                  <CaseIcon className="mr-16" />
                  <span>Careers</span>
                </a>
              </li>
            </ul>
          </nav>
          <div className="flex-grow d-flex flex-column justify-end">
            <Text size="h4" weight="bold" className={styles.version}>
              v{config.app.version}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideNav;
